import {AvailableReportColumnType} from '../type/available-report-column.type';
import {Selectable} from '../../../core/interfaces/selectable.interface';

export class AvailableReportColumn implements Selectable<AvailableReportColumn> {
  constructor(
    public readonly column: string,
    public readonly name: string,
    public readonly fieldType: AvailableReportColumnType) {
  }

  get value(): this {
    return this;
  }

  get displayName(): string {
    return this.name;
  }

  toSelectText(): string {
    return this.name;
  }

  toSelectDescription?(): string {
    return `Wybrana kolumna: ${this.column}`;
  }
}
